import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Building2 } from 'lucide-react';
import Button from '@components/common/Button';

const UniversityDetails = () => {
  const { universityId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div className="mb-6">
        <Button
          onClick={() => navigate('/student/portfolio')}
          variant="ghost"
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Portfolio
        </Button>

        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-secondary-100 flex items-center justify-center">
            <Building2 className="w-8 h-8 text-secondary-600" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              University Details
            </h1>
            <p className="text-sm text-gray-600">
              University ID: {universityId}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="text-center py-12">
          <Building2 className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            University Details Coming Soon
          </h2>
          <p className="text-gray-600">
            Detailed information about this university will be available here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UniversityDetails;
